module.exports = __webpack_public_path__ + "static/img/0-3home.6503e2ab.png";